import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { BASE_URL } from "../env";
import axios from "axios";
import "../Assets/scss/particularData.scss";

const ShowAllCourses = () => {
	const [courses, setCourses] = useState([]);

	const AllCourses = async () => {
		try {
			const res = await axios({
				method: "get",
				url: `${BASE_URL}/smallCourses/getAllcourses`,
				headers: {
					authorization: "Bearer " + localStorage.getItem("token"),
				},
			});
			setCourses(res.data.data);
			console.log(res.data);
		} catch (error) {
			console.log("error");
		}
	};

	useEffect(() => {
		AllCourses();
	}, []);

	return (
		<>
			<div className="showAllCourse">
				<div className="allCourseTitle">All Courses</div>
				<div className="container">
					<div className="row">
						{courses.map((val, index) => {
							return (
								<div className="col-md-4">
									<NavLink
										to={`/showallcourseid/${val._id}`}
										className="courseTitle"
										key={index}
									>
										{val.name}
									</NavLink>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</>
	);
};

export default ShowAllCourses;
